import React, { useState, useEffect } from 'react';
import { BoldButton } from '@bold/web-components-react';
import { StaticImage } from 'gatsby-plugin-image';
import SegmentButton from 'components/website/SegmentButton';
import IRight from 'assets/images/global/svg/ic_chevron_right_w.inline.svg';

const SlidePaymentLink = ({ size, refValue }) => {
  const [image, setImage] = useState();

  useEffect(() => {
    const QUERY = {
      sm: (
        <StaticImage
          className="hero-main-image"
          src="./images/banner-linkpago2-sm.jpg"
          alt="Bold"
          loading="eager"
          fetchpriority="high"
        />
      ),
      md: (
        <StaticImage
          className="hero-main-image"
          src="./images/banner-linkpago2-md.jpg"
          alt="Bold"
          loading="eager"
          fetchpriority="high"
        />
      ),
      xx: (
        <StaticImage
          className="hero-main-image"
          src="./images/banner-linkpago2-xx.jpg"
          alt="Bold"
          loading="eager"
          fetchpriority="high"
        />
      ),
    };

    setImage(QUERY[size]);
  }, [size]);

  return (
    <>
      <div className="hero-slider-container overlay" ref={refValue}>
        {image}
        <div className="content-slider">
          <div className="info-center">
            <div className="show-mobile">
              <div>
                <h1>
                  Vende a cualquier lugar
                  <br /> del mundo con nuestro
                  <br /> Link de pago
                </h1>
                <p className="banner-paragraph">¡Descarga la App Bold y comienza ahora!</p>
              </div>
            </div>
            <div className="show-tablet">
              <div>
                <h1>
                  Vende a cualquier
                  <br /> lugar del mundo
                  <br /> con nuestro Link
                  <br /> de pago
                </h1>
                <p className="banner-paragraph">¡Descarga la App Bold y comienza ahora!</p>
              </div>
            </div>
            <div className="show-desktop">
              <div>
                <h1>
                  Vende a cualquier
                  <br /> lugar del mundo
                  <br /> con nuestro Link
                  <br /> de pago
                </h1>
                <p className="banner-paragraph">¡Descarga la App Bold y comienza ahora!</p>
              </div>
            </div>

            <SegmentButton
              event="button"
              url="/linkdepago#empezar"
              isLink
              obj={{
                page_section: 'old_hero',
                banner_name: 'link_de_pago',
                redirect_to: 'linkdepago',
              }}
            >
              <BoldButton className="hero-btn" size="default" color="accent" type="button">
                Empezar a usar
                <IRight slot="end" alt="Bold" />
              </BoldButton>
            </SegmentButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default SlidePaymentLink;
